// =============================================================================================================
// SAML Connection Hooks
// =============================================================================================================
import { useCallback } from 'react';
import { useStytchCreateSAMLConnection, useStytchUpdateSAMLConnection, useStytchUpdateSAMLConnectionByURL, } from '../../../../services/stytch/client';
export function useCreateSAMLConnection() {
    const createSAMLConnection = useStytchCreateSAMLConnection();
    return useCallback(async (data) => {
        const result = await createSAMLConnection(data);
        if (result.success) {
            return {
                success: true,
                statusCode: result.statusCode,
                connection: result.connection,
                data: result.data,
            };
        }
        return { success: false, error: result.error, data: result.data };
    }, [createSAMLConnection]);
}
export function useUpdateSAMLConnection() {
    const updateSAMLConnection = useStytchUpdateSAMLConnection();
    return useCallback(async (data) => {
        const result = await updateSAMLConnection(data);
        if (result.success) {
            return {
                success: true,
                statusCode: result.statusCode,
                connection: result.connection,
                requestId: result.requestId,
                data: result.data,
            };
        }
        else {
            return {
                success: false,
                error: result.error,
                data: result.data,
            };
        }
    }, [updateSAMLConnection]);
}
/**
 * Update SAML connection using IdP metadata URL.
 * This is the SAFEST way to configure SAML - the IdP provides all config via the metadata URL.
 */
export function useUpdateSAMLConnectionByURL() {
    const updateSAMLConnectionByURL = useStytchUpdateSAMLConnectionByURL();
    return useCallback(async (data) => {
        const result = await updateSAMLConnectionByURL(data);
        if (result.success) {
            return {
                success: true,
                statusCode: result.statusCode,
                connection: result.connection,
                requestId: result.requestId,
                data: result.data,
            };
        }
        else {
            return {
                success: false,
                error: result.error,
                data: result.data,
            };
        }
    }, [updateSAMLConnectionByURL]);
}
